// @flow

import { type ConfirmedIncomingPayment, type PendingIncomingPayment } from './types';

export function getMustRedirectAfterPaymentConfirmed(incomingPayment: ConfirmedIncomingPayment|PendingIncomingPayment): boolean {
  if (incomingPayment.v2 && incomingPayment.v2.redirect)
    return !!incomingPayment['v2']['redirect']['must_redirect_after_payment_confirmed'];

  return !!incomingPayment['must_redirect_after_payment_confirmed'];
}
